import { getRuntimeEnv } from "config/runtimeEnv";

const runtimeEnv = getRuntimeEnv();
export const { ENV, API_DOMAIN } = runtimeEnv;
export const IS_REAL = ENV === "release"; // 리얼API 사용 여부

// root 도메인
export const ROOT_DOMAIN = "after10m.com";
// 개발 서브 도메인
const DEV_SUB_DOMAIN: string = "dev";
// api 도메인
export const DEV_API_DOMAIN = `api-${DEV_SUB_DOMAIN}.${ROOT_DOMAIN}`;
// api http context
export const API_HTTP_CONTEXT = API_DOMAIN ?? `https://${DEV_API_DOMAIN}`;
// image http context
export const API_IMAGE_CONTEXT = `${API_HTTP_CONTEXT}/images`;
// 외부공유용 도메인
// export const PUBLIC_DOMAIN = IS_REAL
//   ? `https://www.${ROOT_DOMAIN}`
//   : API_HTTP_CONTEXT;
